<template>
  <v-card class="mt-5">
    <AppVCardTitleWithButton label="Contrôle distributeur"
                             image_url="/img/implementedForms/62b97ed722d02/distrubutorControl.png"/>
    <AppCheckboxWithButton v-model='value.filterBypassOpeningControl'
                           label='Contrôle de la bonne fermeture du bypass du filtre sur le distributeur *'
                           image_url='/img/implementedForms/62b97ed722d02/by-pass.png' :required="true"/>
    <AppCheckboxWithButton v-model="value.presenceSticker" label='Présence du Sticker "Numéro vert Oleo100"' image_url="/img/implementedForms/62b97ed722d02/tollFreeNumberSticker.png" />
    <AppRadioYesNo v-model="value.isValveSealed" label="La vanne de bypass est elle bien plombée"/>
    <v-card-text class="pt-0 pb-0">
      Prendre du bypass *
      <AppImageInput v-model="image" placeholder="Ajouter une image du bypass" :rules="[v => !!v && v.length === 1]"/>
    </v-card-text>

    <v-card-text class="pt-0 pb-0">
      Photo de la filtration *
      <AppImageInput v-model="filtration_image" placeholder="Ajouter une image de la filtration" :rules="[v => !!v && v.length === 1]"/>
    </v-card-text>

    <v-card-text class="pt-0 pb-0">
      Photo du Sticker *
      <AppImageInput v-model="sticker_image" placeholder="Ajouter une image de l'emplacement du Sticker" :rules="[v => !!v && v.length === 1]"/>
    </v-card-text>

    <v-card-text class="pt-0 pb-0">
      Photos des 4 côtés du distributeur *
      <AppImageInput v-model="distributeur_images" placeholder="Ajouter des images des 4 côtés du distributeur" :rules="[v => (!!v && v.length === 4)]" multiple />
    </v-card-text>

  </v-card>
</template>

<script>
import AppCheckboxWithButton
  from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/CheckboxWithButton";
import AppRadioYesNo from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/RadioYesNo";
import AppImageInput from "@/components/App/ImageInput.vue";
import AppVCardTitleWithButton from "@/components/MaintenanceViewReport/ImplementedForms/Oleo100Preventive/App/VCardTitleWithButton";

export default {
  name: "ControlOfTheDistributor",
  components: {
    AppVCardTitleWithButton,
    AppCheckboxWithButton,
    AppRadioYesNo,
    AppImageInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      image: this.value.valvePicture ?? null,
      filtration_image: this.value.filtrationPicture ?? null,
      sticker_image: this.value.stickerPicture ?? null,
      distributeur_images: this.value.distributeurPicture ?? null,
    };
  },
  watch: {
    image(newValue) {
      this.value.valvePicture = newValue
    },
    filtration_image(newValue) {
      this.value.filtrationPicture = newValue
    },
    sticker_image(newValue) {
      this.value.stickerPicture = newValue
    },
    distributeur_images(newValue) {
      this.value.distributeurPicture = newValue
    },
  },
};
</script>
